import "zendare-ui";
import "@ionic/core";

import { setupConfig } from "@ionic/core";
import { APP_CONFIG } from "../config";

export default function() {
  setupConfig({
    mode: APP_CONFIG.mode === "ios" ? "ios" : "md",
  });
}
